import { BackendApi } from "./BackendApi";
import { ApiRoute } from "./ApiRoute";
import { AxiosResponse } from "axios";
import { NavigateFunction } from "react-router";

const login = (
  username: string,
  password: string,
  succFunc: (res: AxiosResponse) => void,
  errFunc: (res: AxiosResponse | string) => void,
) => {
  const bodyObj = {
    username: username,
    password: password,
  };
  return BackendApi.post(ApiRoute.login, bodyObj, succFunc, errFunc);
};

const logout = (navigate: NavigateFunction) => {
  const succFunc = (response: AxiosResponse /*: any*/) => {
    navigate("/login");
  };
  const errFunc = (response: AxiosResponse | string /*: any*/) => {};
  return BackendApi.post(ApiRoute.logout, {}, succFunc, errFunc);
};

const auth = (
  succFunc: (response: AxiosResponse) => void,
  errFunc: (response: AxiosResponse | string) => void,
) => {
  return BackendApi.post(ApiRoute.auth, {}, succFunc, errFunc);
};

const reset = (
  param: string,
  succFunc: (response: AxiosResponse) => void,
  errFunc: (response: AxiosResponse | string) => void,
) => {
  return BackendApi.get(ApiRoute.reset, { param: param }, succFunc, errFunc);
};

export const AuthFunctions = {
  login: login,
  logout: logout,
  auth: auth,
  reset: reset,
};
